import { createAppAsyncThunk } from '../store/extensions';
import { HealthJourneyDto } from './dtos';
import { HealthPictureItem } from './model';
import {
  createNewJourneyCall,
  deleteHealthJourneyCall,
  deleteHistoricalHealthPictureCall,
  fetchHealthJourneysCall,
  fetchHealthJourneyTimelineCall,
  fetchHealthPictureCall,
  fetchSymptomCheckerResultsCall,
  updateHealthJourneyCall,
  updateHealthPictureCall,
} from './service';

export const createNewJourney = createAppAsyncThunk(
  'healthJourney/insertJourney',
  (healthJourney: HealthJourneyDto) => {
    return createNewJourneyCall(healthJourney);
  }
);

export const fetchHealthJourneys = createAppAsyncThunk(
  'healthJourney/getHealthJourneys',
  () => {
    return fetchHealthJourneysCall();
  }
);

export const updateHealthJourney = createAppAsyncThunk(
  'healthJourney/updateJourney',
  (args: { journeyId: string; healthJourney: HealthJourneyDto }) => {
    return updateHealthJourneyCall(args.journeyId, args.healthJourney);
  }
);

export const deleteHealthJourney = createAppAsyncThunk(
  'healthJourney/deleteJourney',
  (args: { journeyId: string }) => {
    return deleteHealthJourneyCall(args.journeyId);
  }
);

export const fetchHealthPicture = createAppAsyncThunk(
  'healthPicture/fetch',
  (journeyId: string) => {
    return fetchHealthPictureCall(journeyId);
  }
);

export const updateHealthPicture = createAppAsyncThunk(
  'healthPicture/update',
  (healthPicture: HealthPictureItem) => {
    return updateHealthPictureCall(healthPicture);
  }
);

export const fetchHealthJourneyTimeline = createAppAsyncThunk(
  'healthJourney/getTimeline',
  (args: { journeyId: string; xMsContinuationToken?: string }) => {
    return fetchHealthJourneyTimelineCall(
      args.journeyId,
      args.xMsContinuationToken
    );
  }
);

export const deleteHistoricalHealthPicture = createAppAsyncThunk(
  'historicalHealthPicture/delete',
  (pictureId: string) => {
    return deleteHistoricalHealthPictureCall(pictureId);
  }
);

export const fetchSymptomCheckerResults = createAppAsyncThunk(
  'healthJourney/symptomCheckerResults',
  (journeyId: string) => {
    return fetchSymptomCheckerResultsCall(journeyId);
  }
);
